import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { BATCH_CONFIG } from './base/batch-config';

/**
 * Batch Feature Routes
 *
 * 배치 실행 유틸리티 (단일 페이지):
 * - /paywith-master/batch
 */
export const batchRoutes: Routes = [
  {
    path: BATCH_CONFIG.routePath,
    loadComponent: () =>
      import('./components/smart/batch-page/batch-page.component').then(
        (m) => m.BatchPageComponent,
      ),
    canActivate: [roleGuard('ADMIN_SYSTEM')],
  },
];
